export enum HazardType {
    Unknown = 0,
    Biological = 1,
    Chemical = 2,
    Radiological = 3,
    Nuclear = 4,
    Explosive = 5,
}